export const openNewWindow = (link: string): void => {
  window.open(link, "_blank");
};

export const redirectTo = (url: string): void => {
  window.location.href = url;
};

export const stripHtmlTags = (input: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(input, "text/html");
  return doc.body.textContent?.trim() || "";
};

export const trimTrailingSlashes = (path: string) => {
  while (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  return path;
};
